module.exports = flarum.core.compat['models/Forum'];